import { createContext } from 'react'

import { Config } from './types'

const context = createContext<Config | undefined>(undefined)

export default context
